module.exports = __webpack_public_path__ + "img/emv_naked.6bca792b.svg";